var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("div", { staticClass: "logo row" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "column" }, [
          _c("a", { attrs: { href: _vm.jiraAuthLink } }, [_vm._v("Auth")])
        ])
      ]),
      _vm._v(" "),
      _vm.newTicketView
        ? _c("new-ticket", {
            on: {
              cancel: function($event) {
                _vm.newTicketView = false
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "a-list",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.newTicketView,
              expression: "!newTicketView"
            }
          ],
          staticClass: "row",
          attrs: {
            "item-layout": "horizontal",
            "data-source": _vm.renderedTickets,
            pagination: _vm.pagination,
            bordered: ""
          },
          scopedSlots: _vm._u([
            {
              key: "renderItem",
              fn: function(item) {
                return _c(
                  "a-list-item",
                  {
                    on: {
                      click: function($event) {
                        return _vm.toggleCheckbox(item.key)
                      }
                    }
                  },
                  [
                    _c("a-list-item-meta", [
                      _c(
                        "span",
                        { attrs: { slot: "title" }, slot: "title" },
                        [
                          _c(
                            "a-tooltip",
                            {
                              attrs: {
                                title: "Link this ticket to PR",
                                "mouse-enter-delay": 0.5,
                                placement: "left"
                              }
                            },
                            [
                              _c("a-icon", {
                                class: { active: item.linked },
                                staticStyle: { "font-size": "20px" },
                                attrs: { type: "api" }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("strong", [
                            _c("img", {
                              staticClass: "ticketIcon",
                              attrs: {
                                src: item.icon,
                                width: "16",
                                height: "16"
                              }
                            }),
                            _vm._v(" " + _vm._s(item.key))
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(item.summaryText))])
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        attrs: {
                          slot: "actions",
                          href: item.externalLink,
                          target: "_blank"
                        },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                          }
                        },
                        slot: "actions"
                      },
                      [
                        _c(
                          "a-tooltip",
                          {
                            attrs: {
                              title: "Open Jira ticket",
                              "mouse-enter-delay": 0.5,
                              placement: "right"
                            }
                          },
                          [_c("a-icon", { attrs: { type: "link" } })],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              }
            }
          ])
        },
        [
          _c("a-input-search", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.newTicketView,
                expression: "!newTicketView"
              }
            ],
            attrs: {
              slot: "header",
              placeholder: "Search",
              "enter-button": ""
            },
            slot: "header",
            model: {
              value: _vm.searchStr,
              callback: function($$v) {
                _vm.searchStr = $$v
              },
              expression: "searchStr"
            }
          }),
          _vm._v(" "),
          _vm._v(" "),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "a-button",
                {
                  staticClass: "submit",
                  attrs: {
                    loading: _vm.loading,
                    type: "primary",
                    disabled: _vm.linkedItems.length === 0
                  },
                  on: { click: _vm.done }
                },
                [
                  _vm._v(
                    "\n        Link " +
                      _vm._s(_vm.linkedItems.length) +
                      " item(s)\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "a-button",
                {
                  on: {
                    click: function($event) {
                      _vm.newTicketView = true
                    }
                  }
                },
                [_vm._v("New Ticket")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column" }, [
      _c("img", {
        staticStyle: { width: "40px", height: "40px", "border-radius": "50%" },
        attrs: {
          alt: "Quantify",
          src:
            "https://s3.amazonaws.com/quantify-web-assets/identity/quantify_icon_jira.png"
        }
      }),
      _vm._v(" "),
      _c("br"),
      _vm._v("Quantify\n    ")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }